import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { AppConfigService } from '@pulse/common';

import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MyProfileService {
  getAllPrefs = 'preferences/all';
  languageChangeBehaviourSubject = new BehaviorSubject(null);
  constructor(private http: HttpClient, private appConfig: AppConfigService) { }

  getAllPreferences(): Observable<any> {
    return this.http.get<any>(this.appConfig.getApi('globalUserMgmtAPI') + this.getAllPrefs);
  }

  save(postBody): Observable<any> {
    return this.http.post<any>(this.appConfig.getApi('globalUserMgmtAPI') + 'preferences/save', postBody);
  }
}
